const envSettings = window as Window;

declare global {
  interface Window {
    _env_: Record<string, string>;
  }
}

export class Config {
  static allowedTenants = envSettings._env_?.REACT_APP_ALLOWED_TENANTS;
  static apiUrl = envSettings._env_?.REACT_APP_API_URL;
  static authClientId = envSettings._env_?.REACT_APP_AUTH_CLIENT_ID;
  static authUrl = envSettings._env_?.REACT_APP_AUTH_URL;
  static baseUrl = envSettings._env_?.REACT_APP_ROUTER_BASENAME;
  static clientUrl = envSettings._env_?.REACT_APP_CLIENT_URL;
  static nodeEnv = envSettings._env_?.NODE_ENV;
  static releaseVersion = envSettings._env_?.REACT_APP_RELEASE_VERSION;
  static tokenExpiration = envSettings._env_?.REACT_APP_TOKEN_EXPIRATION;
  static ntpOffsetLimitMs = parseInt(
    envSettings._env_?.REACT_APP_NTP_OFFSET_LIMIT_MS
  );
}
